import WidgetBienvenue from './WidgetBienvenue.vue'
import WidgetCaDuMois from './WidgetCaDuMois.vue'
import WidgetFacturesAchat from './WidgetFacturesAchat.vue'
import WidgetMesTaches from './WidgetMesTaches.vue'
import WidgetMonEquipe from './WidgetMonEquipe.vue'
import WidgetNotifications from './WidgetNotifications.vue'
import WidgetNouveautes from './WidgetNouveautes.vue'
import WidgetPostesEnDefaut from './WidgetPostesEnDefaut.vue'
import WidgetRaccourcis from './WidgetRaccourcis.vue'
import WidgetStockAlertes from './WidgetStockAlertes.vue'
import WidgetTickets from './WidgetTickets.vue'

/**
 * Quelle clé de widget se rend avec quel composant.
 *
 * La liste est écrite à la main, comme le registre du serveur : une clé servie
 * par le serveur sans composant ici n'est pas posée du tout, et c'est voulu —
 * on ne devine pas un rendu pour une clé qu'on ne connaît pas, et une case vide
 * sur l'accueil se lirait comme un widget en panne.
 *
 * Ce fichier ne dépend de rien : c'est lui que le composable interroge, pas
 * l'inverse.
 *
 * Les raccourcis figurent au catalogue du serveur comme les autres, et non en
 * marge : c'est ce qui permet à l'utilisateur de les déplacer et de les retirer
 * pour de bon. Un widget que le front réinsérerait de lui-même à chaque
 * chargement ne pourrait jamais être retiré, son absence n'étant enregistrable
 * nulle part.
 */

export const COMPOSANTS = {
    bienvenue: WidgetBienvenue,
    raccourcis: WidgetRaccourcis,
    'mes-taches': WidgetMesTaches,
    'mon-equipe': WidgetMonEquipe,
    'ca-du-mois': WidgetCaDuMois,
    'factures-achat-a-ventiler': WidgetFacturesAchat,
    'stock-alertes': WidgetStockAlertes,
    notifications: WidgetNotifications,
    tickets: WidgetTickets,
    'postes-en-defaut': WidgetPostesEnDefaut,
    nouveautes: WidgetNouveautes,
}

export function composantDe(cle) {
    return COMPOSANTS[cle] ?? null
}

/**
 * Les widgets qui n'ont rien à demander au serveur.
 *
 * Les raccourcis se rendent depuis les routes et les droits déjà présents dans
 * le magasin : leur `data()` côté serveur renvoie un tableau vide, et l'appeler
 * coûterait un aller-retour pour rien sur l'écran le plus ouvert de
 * l'application. Les nouveautés de même : les notes de version voyagent dans le
 * bundle.
 */
const SANS_DONNEES = new Set(['raccourcis', 'nouveautes'])

export function demandeSesDonnees(cle) {
    return !SANS_DONNEES.has(cle)
}
